import type { CloudMarketplace } from '../../productsListing/types'
import {
  getAzureProductsWithDimensions,
  getProductsWithDimensions,
} from '../../../api/mappingManager'

export const getProductsWithDimensionsByCloud = (
  partnerId: string,
  cloudMarketplace: CloudMarketplace
) => {
  switch (cloudMarketplace) {
    case 'AZURE':
      return getAzureProductsWithDimensions(partnerId)
    default:
      return getProductsWithDimensions(partnerId)
  }
}
